'use client';

import { useFlagsProxy } from '@modules/feature-flags/hooks/useFlagsProxy';
import { getUTMs } from '@utils/utm';

import { useAuth0 } from '@auth0/auth0-react';
import { RedirectLoginOptions } from '@auth0/auth0-spa-js';
import React, { useEffect } from 'react';

export const AuthorizePage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const { cloudControlPlaneCdnUi } = useFlagsProxy();
  const utms = getUTMs();

  const redirectUri = cloudControlPlaneCdnUi
    ? process.env.AUTH_CLIENT_UNIFIED_REDIRECT_URI
    : process.env.AUTH_CLIENT_REDIRECT_URI;

  useEffect(() => {
    const authParams: RedirectLoginOptions = {
      authorizationParams: {
        redirectUri,
        ...utms,
      },
    };

    const searchParams = new URLSearchParams(window.location.search);

    for (const arg of ['organization', 'invitation']) {
      const value = searchParams.get(arg);

      if (value && authParams.authorizationParams) {
        authParams.authorizationParams[arg] = value;
      }
    }

    loginWithRedirect(authParams);
  }, [loginWithRedirect]);

  return null;
};
